import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceListTwo = [
    {
        icon: <FiCast />,
        title: 'The Resilient Professional',
        description: "Mastering Change and Driving Transformation",
        url: "/resilient-professional"
    },
    {
        icon: <FiLayers />,
        title: "Decoupling and Exploiting Your Value",
        description: "Transferable Skills for New Career Domains",
        url: "/exploiting-your-value"
    },
    {
        icon: <FiMonitor />,
        title: "Career Trajectory",
        description: "Discovering Your Purpose and Charting Your Future",
        url: "/career-trajectory"
    },
    {
        icon: <FiUsers />,
        title: "The Value-Driven Leader",
        description: "Cultivating Authenticity and Impact",
        url: "/value-driven-leader"
    }
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceListTwo.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a href={val.url}>
                                <div className="service service__style--2 py-3">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title text-center">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
